"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlanes = void 0;
var getSrcPlane_1 = require("./getSrcPlane");
var getDestPlane_1 = require("./getDestPlane");
var translate2d_1 = require("../../common/translate2d");
var inferMarks_1 = require("./inferMarks");
var getPlanes = function (config) {
    var srcPlane = getSrcPlane_1.getSrcPlane(config);
    var destPlane = getDestPlane_1.getDestPlane(config);
    var dataPointGroup = [];
    config.values.map(function (it) {
        var value = it;
        var series = value.series || [];
        var dataPoints = series.map(function (it, i) { return translate2d_1.translate2d([i, it], srcPlane, destPlane); });
        dataPointGroup.push(dataPoints);
    });
    var yAxisMarks = inferMarks_1.inferMarks(srcPlane, destPlane, config.yAxis.lineDensity);
    return {
        dataPointGroup: dataPointGroup,
        yAxisMarks: yAxisMarks,
        destPlane: destPlane
    };
};
exports.getPlanes = getPlanes;
